<ion-icon [name]="icon" [ngStyle]="{ color: _color }"></ion-icon>
<h1
  [ngClass]="{
    'not-root-page': !showUserID
  }"
>
  {{ title }}
</h1>
<div
  *ngIf="showUserID && loginID"
  class="user-id"
  [ngStyle]="{ background: _color_alpha }"
  [style.--bg-color]="_color_alpha"
>
  ID: <span>{{ loginID }}</span>
</div>
